import { render } from "./TitleContainer.vue?vue&type=template&id=4b5d6939"
import script from "./TitleContainer.vue?vue&type=script&lang=js"
export * from "./TitleContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__